module.exports = __webpack_public_path__ + "media/images/top-parts-05-8d5f790dcf7ed1342978f8ea849fe6c6.jpg";